import React, {useEffect} from 'react'
import html2pdf from 'html2pdf.js'

const DownloadPDFButton = ({
  name = '',
  url = '',
  className,
  disable = false,
  windowPrint = false,
}: any) => {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'p') {
        event.preventDefault() // Stop default print dialog
        if (!disable) {
          handleDownload() // Execute only if not disabled
        }
      }
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => {
      window.removeEventListener('keydown', handleKeyDown)
    }
  }, [disable])

  const handleDownload = () => {
    windowPrint ? window.print() : window.open(url, '_blank', 'noopener,noreferrer')
    // const element = document.getElementById('pdf-content') // Provide an ID to the root element
    // console.log({element})
    // if (element) {
    //   const opt = {
    //     margin: 10,
    //     filename: `${name}.pdf`,
    //     image: {type: 'jpeg', quality: 0.98},
    //     html2canvas: {scale: 2},
    //     jsPDF: {unit: 'mm', format: 'a4', orientation: 'portrait'},
    //   }
    //   html2pdf().from(element).set(opt).save()
    // }
  }

  return (
    <button
      type='button'
      className={(className && className) || 'btn btn-primary  px-6'}
      onClick={() => handleDownload()}
      style={{backgroundColor: 'black', float: 'right'}}
      disabled={disable}
    >
      Download PDF
    </button>
  )
}

export default DownloadPDFButton
